import React from "react"
import VersusPage from "../../templates/hotels/VersusPage"

const Page = () => <VersusPage duelKey="monteverdiVsRosewood" locale="fr" />

export default Page
